import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'persons/person';
const model = 'persons/person';
const wizardName = 'Car Configuration Access Management';
const wizardObject = 'Car';
const wizardAction = 'configuratorManagementSingle';

const ConfiguratorManagementSingle = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(false);
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const person = discover('person');
    const [segmentList, setSegmentList] = useState();
    const { items: segments, loadAll: loadAllSegments } = useDataProvider('infocar/getAvailableSegments/' + person?.employment?.legalEntity?._id);

    useEffect(() => {
        loadAllSegments().then((segments) => {
            if (segments.type == 'GETALL_FAILURE') {
                setSegmentList(segments);
                setDrawable(true);
            } else {
                let sl = segments?.items?.map((segment) => {
                    return {
                        "label": segment.Descrizione,
                        "value": segment.Descrizione,//segment.Codice
                    }
                });
                setSegmentList(sl);
                setDrawable(true);
            }
        });
    }, []);

    const detailConfig = {
        "tabs": [
            {
                "name": "configuration",
                "fieldsets": [
                    {
                        "name": "configuration",
                        "fields": {
                            "configuration": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "fleetConfigurationActive": {
                                "type": "select",
                                "required": true,
                                "options": [
                                    {
                                        "label": "true",
                                        "value": "true"
                                    },
                                    {
                                        "label": "false",
                                        "value": "false"
                                    }
                                ],
                                "className": "col-4",
                                "icon": "faToggle"
                            },
                            "fleetConfigurationLinkValid_at": {
                                "type": "date",
                                "required": true,
                                "className": "col-4",
                                "icon": "faCalendarHeart"
                            },
                            "fleetConfigurationLinkExpire_at": {
                                "type": "date",
                                "required": true,
                                "className": "col-4",
                                "icon": "faCalendarXmark"
                            },
                            "segment": {
                                "type": "select",
                                "required": true,
                                "options": (segmentList?.type == 'GETALL_FAILURE') ? [] : segmentList,
                                "className": "col-12",
                                "icon": "faCircleX"
                            },
                            "fleetDriverCode": {
                                "type": "text",
                                "required": true,
                                "readonly": true,
                                "className": "col-4",
                                "icon": "faPerson"
                            },
                            "email": {
                                "type": "email",
                                "required": true,
                                "readonly": true,
                                "className": "col-4",
                                "icon": "faMessage"
                            },
                            "fleetConfigurationQuantityUnlimited": {
                                "type": "select",
                                "required": true,
                                "options": [
                                    {
                                        "label": "true",
                                        "value": "true"
                                    },
                                    {
                                        "label": "false",
                                        "value": "false"
                                    }
                                ],
                                "className": "col-4",
                                "icon": "faToggle"
                            },
                            "fleetConfigurationLink": {
                                "type": "text",
                                "required": true,
                                "readonly": true,
                                "className": "col-12",
                                "icon": "faGlobe"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const sanitizeFleetDriverCode = (firstname, lastname, id) => {
        const raw = `${firstname ?? ''}${lastname ?? ''}${id ?? ''}`;

        return raw
            .normalize("NFD")                   // Decompone lettere accentate
            .replace(/[\u0300-\u036f]/g, "")    // Rimuove i segni diacritici
            .replace(/['\s]/g, '');             // Rimuove apostrofi e spazi
    }

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        "id": person?._id,
                        "email": person?.email,
                        "segment": person?.employment?.segment,
                        "fleetDriverCode": sanitizeFleetDriverCode(person?.firstname, person?.lastname, person?._id),
                        "fleetConfigurationLink": person?.employment?.fleetConfigurationLink,
                        "fleetConfigurationActive": person?.employment?.fleetConfigurationActive,
                        "fleetConfigurationQuantityUnlimited": person?.employment?.fleetConfigurationQuantityUnlimited,
                        "fleetConfigurationLinkValid_at": person?.employment?.fleetConfigurationLinkValid_at,
                        "fleetConfigurationLinkExpire_at": person?.employment?.fleetConfigurationLinkExpire_at
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    readonly={(segmentList.type == 'GETALL_FAILURE') ? true : false}
                    errorMessage={(segmentList.type == 'GETALL_FAILURE') ? t('LegalEntity not allowed to configure') : errorMessage}
                    title={t(wizardName)}
                    canSave={(segmentList.type == 'GETALL_FAILURE') ? false : userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t(wizardName)}
                            subtitle={t('Manage the access to Car Configurator for {{firstname}} {{lastname}}', { wizardObject: wizardObject, firstname: person?.firstname, lastname: person?.lastname })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default ConfiguratorManagementSingle;